
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { parseTime } from '@/utils'
import { dateToSeconds, getCurrentDate, pickerAddOptions, dateToTimezone } from '@/utils/dateTime'
import moment from 'moment'
const initDate = getCurrentDate()

@Component({
  name: 'editAccountConfig',
  components: {
  },
  filters: {
    parseTime(date) {
      return parseTime(date, '{y}-{m}-{d} {h}:{i}:{s}')
    }
  }
})
export default class extends Vue {
  @Prop({ required: true }) formData!: any[]
  @Prop({ required: false }) tableValue!: any[]
  @Prop({ default: true }) isNewFound!: boolean // 新建或者编辑

  private formInline: any = {
  }
  private pickerOptions = pickerAddOptions
  private date: any = ''
  private editDate:any = getCurrentDate()[0]
  // 创建时间监听
  @Watch('date', { deep: true, immediate: true })
  private pickerChange(old) {
    if (old) {
      this.formData.forEach(item => {
        if (item.type === 'time') {
          this.formInline[item.key] = dateToSeconds(this.date)
        }
      })
    }
    // } else {
    //   this.date = getCurrentDate()[0]
    // }
  }

  // 编辑时间监听
  @Watch('dialogVisible', { deep: true, immediate: true })
  private pickerEditChange() {
    this.formData.forEach(item => {
      if (item.type === 'time') {
        this.editData[item.key] = dateToSeconds(this.editDate)
      }
    })
  }

  private tableData: any[] = []
  private dialogVisible: any = false
  // 关闭弹框
  private closeDialogVisible () {
    this.dialogVisible = false
    this.editIndex = ''
    this.editDate = getCurrentDate()[0]
    // this.editData = {}
  }
  // 更新数据 editData
  private editWalletClick () {
    this.tableData[this.editIndex] = this.editData
    this.dialogVisible = false
    this.editIndex = ''
    // this.editDate = getCurrentDate()[0]
    // this.editData = {}
    this.$emit('changeAddMoney', this.tableData)
  }

  // 重置
  private resetting () {
    this.formInline = {}
  }
  // 新增
  private addMoneyText () {
    if (this.tableData === undefined) {
      this.tableData = []
    }
    // 必填不能为空数组
    let requiredList = this.formData.filter(item => {
      return item.required === true
    })
    // 不能重复数组
    let onlyList = this.formData.filter(item => {
      return item.only === true
    })
    // 第一种情况：this.tableData = [], 只要考虑必填是不是为空
    if (this.tableData.length === 0) {
      this.tableData = []
      if (requiredList.length > 0) {
        let oneResult = requiredList.some(item => {
          return this.formInline[item.key] === '' || this.formInline[item.key] === undefined
        })
        this.errorMessage(requiredList, oneResult, this.formInline)
      }
    } else {
      // 有必填，无唯一
      if (requiredList.length > 0 && onlyList.length === 0) {
        let oneResult = requiredList.some(item => {
          return this.formInline[item.key] === '' || this.formInline[item.key] === undefined
        })
        this.errorMessage(requiredList, oneResult, this.formInline)
      } else if (requiredList.length > 0 && onlyList.length > 0) {
        let oneResult = requiredList.some(item => {
          return this.formInline[item.key] === '' || this.formInline[item.key] === undefined
        })
        let errorText: string = ''
        if (oneResult) {
          errorText = this.errorText(requiredList, this.formInline)
        }
        if (oneResult) return this.$message.error(`${errorText} Not Null`)

        let only:any = null
        onlyList.forEach(i => {
          only = this.tableData.some(item => {
            return item[i.key] === this.formInline[i.key]
          })
        })
        this.repeatMessage(onlyList, only, this.formInline)
      } else if (requiredList.length === 0 && onlyList.length > 0) {
        let only:any = null
        onlyList.forEach(i => {
          only = this.tableData.some(item => {
            return i[item.key] === this.formInline[item.key]
          })
        })
        this.repeatMessage(onlyList, only, this.formInline)
      } else {
        this.tableData.push(this.formInline)
        this.resetting()
      }
    }
    // this.resetting()
    // this.date = getCurrentDate()[0]
    this.date = ''
    this.$emit('changeAddMoney', this.tableData)
  }

  // 必填错误提示
  errorMessage (list, flag, form) {
    if (flag) {
      for (let i = 0; i < list.length; i++) {
        if (form[list[i].key] === undefined || form[list[i]] === '') {
          return this.$message.error(`${list[i].text} Not Null`)
        }
      }
    } else {
      console.log(this.tableData, form)
      this.tableData.push(form)
      this.resetting()
    }
  }

  // 重复错误提示
  repeatMessage (list, flag, form) {
    if (flag) {
      this.tableData.forEach(i => {
        // list.some(item => {
        //   return i[item.key] === this.formInline[item.key]
        // })
        list.forEach(element => {
          if (form[element.key] === i[element.key]) {
            return this.$message.error(`${element.text} No Repeat`)
          }
        })
      })
    } else {
      this.tableData.push(form)
      this.resetting()
    }
  }

  // 错误文字
  errorText (list, form) {
    let text:string = ''
    for (let i = 0; i < list.length; i++) {
      if (form[list[i].key] === undefined || form[list[i]] === '' || form[list[i]] === null) {
        text = list[i].text
      }
    }
    return text
  }

  // 删除
  private delTableValue (row) {
    this.tableData.splice(row, 1)
    console.log(this.tableData, 'oooo')

    this.$emit('changeAddMoney', this.tableData)
  }

  // 编辑
  private editData: any = {}
  private editIndex: any = ''
  private editDetail (row, i) {
    console.log(row)
    this.editData = JSON.parse(JSON.stringify(row))
    this.editIndex = i
    this.dialogVisible = true
    // this.formData.forEach(item => {
    //   if (item.type === 'time') {
    //     this.editData[item.key] = moment(row[item.key] * 1000).format('YYYY-MM-DD hh:mm:ss')
    //   }
    //   console.log(this.editData[item.key],'ppp')
    // })
  }

  mounted () {
    // this.getProductLists()
    this.$nextTick(() => {
      let data = this.tableValue && JSON.parse(JSON.stringify(this.tableValue))
      this.isNewFound ? this.tableData = data : this.tableData = []
    })
  }
}
